module.exports = __webpack_public_path__ + "src/assets/img/logogris.82b692b3.svg";